import {
  column,
  type PowerSyncDatabase,
  Schema,
  type SyncStream,
  Table,
} from "@powersync/web";

// OR: import { column, Schema, Table, PowerSyncDatabase, SyncStream } from '@powersync/react-native';

const staff = new Table(
  {
    createdAt: column.text,
    displayLanguage: column.text,
    email: column.text,
    emailVerified: column.integer,
    image: column.text,
    // id column (text) is automatically included
    name: column.text,
    phone: column.text,
    translationLanguage: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const properties = new Table(
  {
    accessMethod: column.text,
    address: column.text,
    adminAreaLevel2: column.text,
    adminAreaLevel3: column.text,
    cancellationPolicy: column.text,
    checkInTime: column.text,
    checkOutTime: column.text,
    city: column.text,
    code: column.text,
    color: column.text,
    countryCode: column.text,
    createdAt: column.text,
    currencyCode: column.text,
    description: column.text,
    houseInfo: column.text,
    houseRules: column.text,
    image: column.text,
    latitude: column.real,
    localTips: column.text,
    logo: column.text,
    longitude: column.real,
    metadata: column.text,
    municipalityCountry: column.text,
    // id column (text) is automatically included
    name: column.text,
    operationalState: column.text,
    phone: column.text,
    placeId: column.text,
    postalCode: column.text,
    preArrivalRefreshSince: column.text,
    receptionCloseTime: column.text,
    receptionOpenTime: column.text,
    region: column.text,
    shortCode: column.text,
    slug: column.text,
    sublocality: column.text,
    timezone: column.text,
    updatedAt: column.text,
    website: column.text,
    wifiPassword: column.text,
    wifiSsid: column.text,
  },
  { indexes: {} }
);

const registration_credentials = new Table(
  {
    // id column (text) is automatically included
    propertyId: column.text,
    status: column.text,
    system: column.text,
  },
  { indexes: {} }
);

const membership = new Table(
  {
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    role: column.text,
    userId: column.text,
  },
  { indexes: {} }
);

const units = new Table(
  {
    amenityIds: column.text,
    // id column (text) is automatically included
    code: column.text,
    createdAt: column.text,
    description: column.text,
    extraBedsCribs: column.integer,
    extraBedsRollaways: column.integer,
    maxAdults: column.integer,
    maxChildren: column.integer,
    maxChildrenPayable: column.integer,
    maxGuests: column.integer,
    name: column.text,
    propertyId: column.text,
    readiness: column.text,
    readinessUpdatedAt: column.text,
    sizeUnit: column.text,
    sizeValue: column.real,
    smokingPolicy: column.text,
    unitTypeId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_units = new Table(
  {
    createdAt: column.text,
    propertyId: column.text,
    // id column (text) is automatically included
    reservationId: column.text,
    unitId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_unit_guests = new Table(
  {
    checkInId: column.text,
    createdAt: column.text,
    guestId: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    reservationUnitId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const check_ins = new Table(
  {
    checkedInAt: column.text,
    checkedInBy: column.text,
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    reservationId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservations = new Table(
  {
    accessibilityNotes: column.text,
    adults: column.integer,
    bookerGuestId: column.text,
    // id column (text) is automatically included
    bookingReference: column.text,
    checkInAt: column.text,
    checkInTime: column.text,
    checkOutAt: column.text,
    checkOutTime: column.text,
    children: column.integer,
    createdAt: column.text,
    currency: column.text,
    dietaryNotes: column.text,
    expectedArrivalEndTime: column.text,
    expectedArrivalTime: column.text,
    externalData: column.text,
    externalId: column.text,
    hasPets: column.integer,
    houseRulesAcceptedAt: column.text,
    infants: column.integer,
    integrationId: column.text,
    integrationMappingId: column.text,
    notes: column.text,
    petNotes: column.text,
    propertyId: column.text,
    source: column.text,
    sourceDetail: column.text,
    status: column.text,
    taxNote: column.text,
    totalAmountMinor: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const property_registration = new Table(
  {
    brief: column.text,
    briefGeneratedAt: column.text,
    briefModel: column.text,
    briefReviewedAt: column.text,
    briefSources: column.text,
    briefStatus: column.text,
    briefVersion: column.integer,
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    routing: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_tax_lines = new Table(
  {
    amountMinor: column.integer,
    breakdown: column.text,
    collectionId: column.text,
    computedAt: column.text,
    createdAt: column.text,
    currency: column.text,
    filedBy: column.text,
    label: column.text,
    missingBirthDates: column.integer,
    // id column (text) is automatically included
    propertyId: column.text,
    reservationId: column.text,
    ruleVersion: column.text,
    status: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_charge = new Table(
  {
    createdAt: column.text,
    currency: column.text,
    description: column.text,
    kind: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    quantity: column.integer,
    reservationId: column.text,
    source: column.text,
    unitAmountMinor: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_payment = new Table(
  {
    amountMinor: column.integer,
    createdAt: column.text,
    currency: column.text,
    method: column.text,
    note: column.text,
    origin: column.text,
    paidAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    reference: column.text,
    reservationId: column.text,
    status: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const rate_plans = new Table(
  {
    baseRateMinor: column.integer,
    boardBasis: column.text,
    createdAt: column.text,
    currencyCode: column.text,
    minRateMinor: column.integer,
    name: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    unitTypeId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const reservation_meal = new Table(
  {
    adultCovers: column.integer,
    adultPriceMinor: column.integer,
    amountMinor: column.integer,
    childCovers: column.integer,
    childPriceMinor: column.integer,
    covers: column.integer,
    createdAt: column.text,
    currency: column.text,
    inclusion: column.text,
    meal: column.text,
    origin: column.text,
    place: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    requestedTime: column.text,
    reservationId: column.text,
    servedAt: column.text,
    serviceDate: column.text,
    status: column.text,
    updatedAt: column.text,
    waivedAt: column.text,
    waivedBy: column.text,
  },
  { indexes: {} }
);

const property_breakfast = new Table(
  {
    adultPriceMinor: column.integer,
    childPriceMinor: column.integer,
    createdAt: column.text,
    currency: column.text,
    defaultInclusion: column.text,
    defaultPlace: column.text,
    enabled: column.integer,
    // id column (text) is automatically included
    propertyId: column.text,
    servedFrom: column.text,
    servedUntil: column.text,
    updatedAt: column.text,
    vatRateBps: column.integer,
  },
  { indexes: {} }
);

const guest_filings = new Table(
  {
    attemptCount: column.integer,
    bucket: column.text,
    confirmedAt: column.text,
    createdAt: column.text,
    deadlineAt: column.text,
    dueAt: column.text,
    escalatedAt: column.text,
    filedManuallyAt: column.text,
    guestId: column.text,
    kind: column.text,
    lastErrorAt: column.text,
    lastErrorCode: column.text,
    lastErrorDetail: column.text,
    lastErrorMessage: column.text,
    lastErrorSource: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    providerRef: column.text,
    receiptId: column.text,
    reservationId: column.text,
    status: column.text,
    submittedAt: column.text,
    system: column.text,
    updatedAt: column.text,
    withdrawnAt: column.text,
  },
  { indexes: {} }
);

const statistics_filings = new Table(
  {
    attemptCount: column.integer,
    confirmedAt: column.text,
    createdAt: column.text,
    deadlineAt: column.text,
    dueAt: column.text,
    escalatedAt: column.text,
    lastErrorCode: column.text,
    lastErrorMessage: column.text,
    periodEnd: column.text,
    periodStart: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    providerRef: column.text,
    region: column.text,
    reportKind: column.text,
    status: column.text,
    submittedAt: column.text,
    system: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const tasks = new Table(
  {
    assignedTo: column.text,
    checklist: column.text,
    cleaningKind: column.text,
    completedAt: column.text,
    completionNote: column.text,
    createdAt: column.text,
    deletedAt: column.text,
    description: column.text,
    endAt: column.text,
    previousCheckOutAt: column.text,
    previousCheckOutTime: column.text,
    previousReservationId: column.text,
    priority: column.text,
    propertyId: column.text,
    startAt: column.text,
    startedAt: column.text,
    status: column.text,
    stayCopiedAt: column.text,
    title: column.text,
    // id column (text) is automatically included
    type: column.text,
    unitId: column.text,
    upcomingAccessibilityNotes: column.text,
    upcomingAdults: column.integer,
    upcomingCheckInAt: column.text,
    upcomingCheckInTime: column.text,
    upcomingChildren: column.integer,
    upcomingDietaryNotes: column.text,
    upcomingExpectedArrivalAt: column.text,
    upcomingHasPets: column.integer,
    upcomingHeadCount: column.integer,
    upcomingInfants: column.integer,
    upcomingPetNotes: column.text,
    upcomingReservationId: column.text,
    upcomingSource: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const rate_seasons = new Table(
  {
    amountMinor: column.integer,
    createdAt: column.text,
    endDate: column.text,
    minStay: column.integer,
    name: column.text,
    occupancyReductionMinor: column.integer,
    priority: column.integer,
    // id column (text) is automatically included
    propertyId: column.text,
    ratePlanId: column.text,
    shortStaySurchargeMinor: column.integer,
    shortStayThresholdNights: column.integer,
    startDate: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const blocks = new Table(
  {
    createdAt: column.text,
    endAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    reason: column.text,
    source: column.text,
    startAt: column.text,
    unitId: column.text,
    unitTypeId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const task_rules = new Table(
  {
    assignedStaffId: column.text,
    assignmentPreset: column.text,
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    requiredFunction: column.text,
    taskType: column.text,
    trigger: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const cleaning_checklist_templates = new Table(
  {
    cleaningKind: column.text,
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    steps: column.text,
    unitId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const property_parking = new Table(
  {
    address: column.text,
    createdAt: column.text,
    instructions: column.text,
    label: column.text,
    latitude: column.real,
    longitude: column.real,
    mapsUrl: column.text,
    photos: column.text,
    placeId: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    sortOrder: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const tax_returns = new Table(
  {
    amountMinor: column.integer,
    collectionId: column.text,
    createdAt: column.text,
    currency: column.text,
    dueOn: column.text,
    filedBy: column.text,
    label: column.text,
    paidMinor: column.integer,
    periodEnd: column.text,
    periodStart: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    stays: column.integer,
    uncomputedReservationIds: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_time_off = new Table(
  {
    createdAt: column.text,
    endDate: column.text,
    note: column.text,
    // id column (text) is automatically included
    staffId: column.text,
    startDate: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_availability_window = new Table(
  {
    createdAt: column.text,
    dayOfWeek: column.integer,
    endTime: column.text,
    // id column (text) is automatically included
    staffId: column.text,
    startTime: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_task_function = new Table(
  {
    createdAt: column.text,
    function: column.text,
    // id column (text) is automatically included
    staffId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const guests = new Table(
  {
    birthCountry: column.text,
    birthPlace: column.text,
    createdAt: column.text,
    dateOfBirth: column.text,
    email: column.text,
    // id column (text) is automatically included
    firstName: column.text,
    idCaptureSource: column.text,
    idDocumentNumber: column.text,
    idDocumentType: column.text,
    idExpiryDate: column.text,
    idIssuingCountry: column.text,
    idVerifiedAt: column.text,
    idVerifiedByStaffId: column.text,
    lastName: column.text,
    nationalIdNumber: column.text,
    nationality: column.text,
    phone: column.text,
    propertyId: column.text,
    residenceAddress: column.text,
    residenceCountry: column.text,
    sex: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const guest_identities = new Table(
  {
    createdAt: column.text,
    externalData: column.text,
    externalId: column.text,
    // id column (text) is automatically included
    guestId: column.text,
    propertyId: column.text,
    transport: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const guest_chats = new Table(
  {
    createdAt: column.text,
    guestId: column.text,
    hasUnreadMessages: column.integer,
    lastMessagePreview: column.text,
    lastMessageTimestamp: column.text,
    lastReadAt: column.text,
    name: column.text,
    propertyId: column.text,
    // id column (text) is automatically included
    reservationId: column.text,
    transports: column.text,
    unreadCount: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const guest_messages = new Table(
  {
    chatId: column.text,
    content: column.text,
    createdAt: column.text,
    detectedLanguage: column.text,
    errorCode: column.integer,
    errorMessage: column.text,
    externalData: column.text,
    // id column (text) is automatically included
    externalId: column.text,
    guestIdentitySenderId: column.text,
    propertyId: column.text,
    readAt: column.text,
    staffSenderId: column.text,
    status: column.text,
    timestamp: column.text,
    translations: column.text,
    transport: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const guest_message_attachments = new Table(
  {
    createdAt: column.text,
    durationSeconds: column.integer,
    fileName: column.text,
    fileSize: column.integer,
    height: column.integer,
    kind: column.text,
    // id column (text) is automatically included
    messageId: column.text,
    mimeType: column.text,
    position: column.integer,
    propertyId: column.text,
    sha256: column.text,
    transcription: column.text,
    transcriptionStatus: column.text,
    updatedAt: column.text,
    url: column.text,
    waveform: column.text,
    width: column.integer,
  },
  { indexes: {} }
);

const guest_message_reactions = new Table(
  {
    createdAt: column.text,
    emoji: column.text,
    membershipId: column.text,
    // id column (text) is automatically included
    messageId: column.text,
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const calls = new Table(
  {
    answeredAt: column.text,
    createdAt: column.text,
    endedAt: column.text,
    propertyId: column.text,
    status: column.text,
    transport: column.text,
    // id column (text) is automatically included
    twilioCallSid: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const call_participants = new Table(
  {
    // id column (text) is automatically included
    callId: column.text,
    createdAt: column.text,
    guestIdentityId: column.text,
    isOriginator: column.integer,
    memberId: column.text,
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const invitation = new Table(
  {
    createdAt: column.text,
    // id column (text) is automatically included
    email: column.text,
    expiresAt: column.text,
    inviterId: column.text,
    propertyId: column.text,
    role: column.text,
    status: column.text,
  },
  { indexes: {} }
);

const suggestions = new Table(
  {
    actionData: column.text,
    chatId: column.text,
    createdAt: column.text,
    description: column.text,
    messageId: column.text,
    propertyId: column.text,
    // id column (text) is automatically included
    title: column.text,
    type: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const property_integrations = new Table(
  {
    createdAt: column.text,
    e164: column.text,
    lastError: column.text,
    platform: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    provider: column.text,
    senderOfflineReasons: column.text,
    senderStatus: column.text,
    status: column.text,
    updatedAt: column.text,
    username: column.text,
    wabaId: column.text,
  },
  { indexes: {} }
);

const property_media = new Table(
  {
    alt: column.text,
    createdAt: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    sortOrder: column.integer,
    unitId: column.text,
    updatedAt: column.text,
    url: column.text,
  },
  { indexes: {} }
);

const place_content = new Table(
  {
    activities: column.text,
    activitiesIntro: column.text,
    createdAt: column.text,
    enquiryEnabled: column.integer,
    facebookUrl: column.text,
    faqs: column.text,
    heroHeadline: column.text,
    highlights: column.text,
    instagramHandle: column.text,
    locationIntro: column.text,
    nearby: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    reviews: column.text,
    seoDescription: column.text,
    seoTitle: column.text,
    story: column.text,
    storyImageUrl: column.text,
    tagline: column.text,
    tiktokUrl: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_chats = new Table(
  {
    createdAt: column.text,
    directKey: column.text,
    hasUnreadMessages: column.integer,
    lastMessagePreview: column.text,
    lastMessageTimestamp: column.text,
    // id column (text) is automatically included
    name: column.text,
    propertyId: column.text,
    unreadCount: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_messages = new Table(
  {
    callId: column.text,
    // id column (text) is automatically included
    chatId: column.text,
    content: column.text,
    createdAt: column.text,
    deletedAt: column.text,
    deletedBy: column.text,
    guestId: column.text,
    kind: column.text,
    propertyId: column.text,
    readAt: column.text,
    reservationUnitId: column.text,
    senderId: column.text,
    taskId: column.text,
    timestamp: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_chat_participants = new Table(
  {
    // id column (text) is automatically included
    chatId: column.text,
    createdAt: column.text,
    lastReadAt: column.text,
    memberId: column.text,
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const staff_message_attachments = new Table(
  {
    createdAt: column.text,
    durationSeconds: column.integer,
    fileName: column.text,
    fileSize: column.integer,
    height: column.integer,
    kind: column.text,
    // id column (text) is automatically included
    messageId: column.text,
    mimeType: column.text,
    position: column.integer,
    propertyId: column.text,
    sha256: column.text,
    transcription: column.text,
    transcriptionStatus: column.text,
    updatedAt: column.text,
    url: column.text,
    waveform: column.text,
    width: column.integer,
  },
  { indexes: {} }
);

const staff_message_reactions = new Table(
  {
    createdAt: column.text,
    emoji: column.text,
    membershipId: column.text,
    // id column (text) is automatically included
    messageId: column.text,
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const ai_chats = new Table(
  {
    createdAt: column.text,
    lastMessagePreview: column.text,
    lastMessageTimestamp: column.text,
    // id column (text) is automatically included
    memberId: column.text,
    name: column.text,
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const ai_chat_messages = new Table(
  {
    // id column (text) is automatically included
    chatId: column.text,
    content: column.text,
    createdAt: column.text,
    parts: column.text,
    propertyId: column.text,
    readAt: column.text,
    role: column.text,
    timestamp: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const rate_calendar = new Table(
  {
    amountMinor: column.integer,
    closedToArrival: column.integer,
    closedToDeparture: column.integer,
    createdAt: column.text,
    date: column.text,
    lastBatchId: column.text,
    maxStay: column.integer,
    minStay: column.integer,
    minStayArrival: column.integer,
    minStayThrough: column.integer,
    // id column (text) is automatically included
    propertyId: column.text,
    ratePlanId: column.text,
    stopSell: column.integer,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const support_conversations = new Table(
  {
    createdAt: column.text,
    customerReadAt: column.text,
    memberId: column.text,
    // id column (text) is automatically included
    propertyId: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const support_messages = new Table(
  {
    author: column.text,
    content: column.text,
    // id column (text) is automatically included
    conversationId: column.text,
    createdAt: column.text,
    propertyId: column.text,
    translations: column.text,
    updatedAt: column.text,
  },
  { indexes: {} }
);

const support_message_attachments = new Table(
  {
    createdAt: column.text,
    height: column.integer,
    // id column (text) is automatically included
    messageId: column.text,
    propertyId: column.text,
    updatedAt: column.text,
    width: column.integer,
  },
  { indexes: {} }
);

export const AppSchema = new Schema({
  ai_chat_messages,
  ai_chats,
  blocks,
  call_participants,
  calls,
  check_ins,
  cleaning_checklist_templates,
  guest_chats,
  guest_filings,
  guest_identities,
  guest_message_attachments,
  guest_message_reactions,
  guest_messages,
  guests,
  invitation,
  membership,
  place_content,
  properties,
  property_breakfast,
  property_integrations,
  property_media,
  property_parking,
  property_registration,
  rate_calendar,
  rate_plans,
  rate_seasons,
  registration_credentials,
  reservation_charge,
  reservation_meal,
  reservation_payment,
  reservation_tax_lines,
  reservation_unit_guests,
  reservation_units,
  reservations,
  staff,
  staff_availability_window,
  staff_chat_participants,
  staff_chats,
  staff_message_attachments,
  staff_message_reactions,
  staff_messages,
  staff_task_function,
  staff_time_off,
  statistics_filings,
  suggestions,
  support_conversations,
  support_message_attachments,
  support_messages,
  task_rules,
  tasks,
  tax_returns,
  units,
});

export type Database = (typeof AppSchema)["types"];

export function typedStreams(db: PowerSyncDatabase) {
  return {
    selectedProperty(params: {
      property_id: string;
      months: string;
    }): SyncStream {
      return db.syncStream("selected_property", params);
    },
  };
}
